export default __webpack_public_path__ + "static/media/cross.391b4f49.png";